module.exports = __webpack_public_path__ + "static/flatart-insta-ss2-229cbf4929a315b6fc7e896ca4c372f3.png";